import {Box} from '@logistics-frontend/blocks/legacy'
import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {useI18n} from '@logistics-frontend/core/i18n'
import {OrderStatus} from '@yandex-taxi/js-integration-api'
import {isCancelableStatus} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {Tariff} from '../../consts'
import {DisplayableOrder} from '../../utils'
import {isActiveStatus} from '../utils'
import CancelButton from './CancelButton'
import Info from './Info'
import ReceiptButton from './ReceiptButton'
import Route from './Route'

export type Props = {
  order: DisplayableOrder
  onClick: VoidFunction
}

const Order: React.FC<Props> = ({order, onClick}) => {
  const t = useI18n()
  const StatusNames: Record<OrderStatus, string> = {
    [OrderStatus.DRAFT]: t('order.status.draft', 'Черновик'),
    [OrderStatus.EXPIRED]: t('order.status.expired', 'Не найден'),
    [OrderStatus.TRANSPORTING]: t('order.status.transporting', 'Выполнение заказа'),
    [OrderStatus.COMPLETE]: t('order.status.complete', 'Завершён'),
    [OrderStatus.WAITING]: t('order.status.waiting', 'Исполнитель на месте'),
    [OrderStatus.SCHEDULING]: t('order.status.scheduling', 'Запланировано'),
    [OrderStatus.DRIVING]: t('order.status.driving', 'Исполнитель в пути'),
    [OrderStatus.SEARCH]: t('order.status.search', 'Поиск исполнителя...'),
    [OrderStatus.CALLING]: t('order.status.calling', ''),
    [OrderStatus.CANCELLED]: t('order.status.cancelled', 'Отменён'),
    [OrderStatus.FAILED]: t('order.status.failed', 'Отменён водителем'),
  }
  const TariffNames: Record<Tariff, string> = {
    [Tariff.CARGO]: t('order.tariffs.cargo', 'Грузовой'),
    [Tariff.COURIER]: t('order.tariffs.courier', 'Пеший курьер'),
    [Tariff.EXPRESS]: t('order.tariffs.express', 'Автокурьер'),
  }
  const statusName = StatusNames[order.status] || order.status
  const tariffName = TariffNames[order.tariff] || order.tariff

  return (
    <Box onClick={onClick}>
      <Info
        endText={
          isCancelableStatus(order.status) && isActiveStatus(order.status) ? (
            <CancelButton order={order} />
          ) : (
            order.history && <ReceiptButton orderId={order.id} />
          )
        }
        startText={tariffName}
      />
      <Divider />
      <Route destination={order.destination} source={order.source} />
      <Divider />
      <Info endText={order.cost} startText={statusName} />
    </Box>
  )
}

export default Order
